import styled, { css } from 'styled-components';

const attrDetailsCss = css`
  & > div {
    background-color: #eee;
    border: 1px solid gray;
    padding: 5px;
  }
`;

export const Container = styled.div`
  ${({ flowDirection }) => (flowDirection === 'row' ? css`
    grid-area: details;
    display: grid;
    grid-gap: 10px;
    grid-auto-flow: column dense;
    border: none;
    max-height: 100vw;
    ${attrDetailsCss}
  ` : css`
    grid-area: details;
    display: grid;
    grid-gap: 10px;
    grid-auto-flow: row dense;
    border: none;
    max-height: 100vh;
    ${attrDetailsCss}
  `)}
`;

export const NestedAttributes = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  padding: 5px;
  grid-gap: 10px;
`;

export const VerticalAttributes = styled.div`
  display: grid;
  grid-auto-flow: row dense;
  grid-row: 1/3;
  grid-column: 2/3;
  grid-gap: 10px;
  & > div {
    border: 1px solid gray;
  }
`;

export const HorizontalAttributes = styled.div`
  display: grid;
  margin-left: 25%;
  grid-auto-flow: column;
  grid-column: 1/2;
  grid-row: 2/3;
  grid-gap: 10px;
  align-items: end;  
  & > div {
    border: 1px solid gray;
  }
`;
